import { Box, Flex, Text, Image, Button } from '@chakra-ui/react'
import imageSrc from 'assets/images/check-yellow.svg'
import { ChakraPrimaryButton, SecondaryButton } from 'components/Button'
import { useLabSchedulingContext } from 'context/LabSchedulingContext/LabSchedulingProvider'
import { Amplitude } from 'utils/amplitude.utils'
import LabCorpLogo from 'assets/images/LabCorpLogo.png'
import { LabSchedulingSource } from 'utils/amplitude.types'
import { RoutePaths } from 'containers/Core/Routes'
import { useHistory } from 'react-router-dom'

const Cancellation = () => {
  const {
    resetLabSchedulingState,
    setCurrentScreen,
    selectedLab,
    amplitudeLabSchedulingMetadata,
    updateAmplitudeLabSchedulingMetadata,
  } = useLabSchedulingContext()
  const history = useHistory()

  const bookHandler = () => {
    Amplitude.labScheduleStart({
      source: LabSchedulingSource.LAB_CANCEL_DONE,
      is_reschedule: false,
      lab_appointment_id:
        amplitudeLabSchedulingMetadata.lab_appointment_id ?? '',
    })
    resetLabSchedulingState()
    updateAmplitudeLabSchedulingMetadata({
      source: LabSchedulingSource.LAB_CANCEL_DONE,
    })
    setCurrentScreen('labSelect')
  }

  const dashboardHandler = () => {
    history.push(`${RoutePaths.DASHBOARD}?from=labScheduling`)
  }

  return (
    <Box bg="white" p={8} borderRadius="lg" boxShadow="lg" width="sm">
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Image src={imageSrc} marginBottom="1rem" />
        <Text fontFamily="Instrument Serif" fontSize="1.5rem">
          Your appointment was cancelled
        </Text>
        <Text>
          Lab work is a crucial step in your care — rebook to gain informative
          insights on your health.
        </Text>
        <ChakraPrimaryButton width="100%" onClick={() => bookHandler()}>
          Book new appointment
        </ChakraPrimaryButton>
        <Button
          variant="outline"
          width="100%"
          height="36px"
          borderRadius="8px"
          borderColor="#141743"
          color="#1F2937"
          onClick={dashboardHandler}
          fontSize="14px"
          fontWeight="600"
          marginTop="1rem"
          _hover={{ bg: 'transparent', borderColor: '#9CA3AF' }}
        >
          Go to Dashboard
        </Button>
        {selectedLab === 'LabCorp' && (
          <Image src={LabCorpLogo} width="90px" marginTop="2.5rem" />
        )}
      </Flex>
    </Box>
  )
}

export default Cancellation
